import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import {MethodResult} from "@/utils/API/ResultTypes/MethodResult";
import {AxiosResponse} from "axios";
import Language from "@/models/Language";
import Industry from "@/models/Industry";
import {ListResult} from "@/utils/API/ResultTypes/ListResult";
import Country from "@/models/Country";


const resource = '/general';

export default {
  listCountries(): Promise<AxiosResponse<ListResult<Country>>> {
    return Repository.post<ListResult<Country>>(
      `${resource}/ListCountries`,
      new ListRequest({page: 1, pageSize: 9999}),
      {withCredentials: true}
    );
  },
  listIndustries(): Promise<AxiosResponse<ListResult<Industry>>> {
    return Repository.post<ListResult<Industry>>(
      `${resource}/ListIndustries`,
      new ListRequest({page: 1, pageSize: 9999}),
      {withCredentials: true}
    );
  },
  listLanguages(): Promise<AxiosResponse<MethodResult<Language[]>>> {
    return Repository.get<MethodResult<Language[]>>(`${resource}/ListLanguages`, {withCredentials: true});
  },
};
